/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type Codec,
  type Decoder,
  type Encoder,
} from '@solana/kit';

export enum AccountInfoField {
  Key,
  Lamports,
  DataLength,
  Owner,
  RentEpoch,
  Executable,
}

export type AccountInfoFieldArgs = AccountInfoField;

export function getAccountInfoFieldEncoder(): Encoder<AccountInfoFieldArgs> {
  return getEnumEncoder(AccountInfoField);
}

export function getAccountInfoFieldDecoder(): Decoder<AccountInfoField> {
  return getEnumDecoder(AccountInfoField);
}

export function getAccountInfoFieldCodec(): Codec<
  AccountInfoFieldArgs,
  AccountInfoField
> {
  return combineCodec(
    getAccountInfoFieldEncoder(),
    getAccountInfoFieldDecoder()
  );
}
